import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { User } from '../../model/user.model';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../auth/jwt.service';
import { DataSharingService } from '../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SitesettingsService {

  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getSiteSettingsKeys() {
    return this.http.get(this.rootUrl + '/api/Settings/GetSettingsKeys');
  }

  getSettingById(id) {

    const settng = {
      settingId: id
    }
    return this.http.post(this.rootUrl + '/api/Settings/GetSettingsById', settng);
  }

  updateSettings(form) {
    return this.http.post(this.rootUrl + '/api/Settings/UpdateSettings', form);
  }


}
